'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import BrandPanel from './BrandPanel';

// Split-canvas onboarding layout. Left rail carries the flow; the right half is
// brand atmosphere. The left column is a fixed viewport height so the footer
// (the primary button) stays pinned at the bottom while the step content scrolls
// on its own, instead of tall steps pushing the button off-screen. Below lg the
// brand panel drops away and the flow takes the full width.
const OnboardingShell = t0 => {
  const $ = _c(15);
  const {
    children,
    footer,
    top,
    fill: t1
  } = t0;
  const fill = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden={true} className="pointer-events-none absolute left-1/2 top-[-14%] h-[520px] w-[820px] max-w-[90vw] -translate-x-1/2 rounded-full opacity-30 blur-[130px]" style={{
      background: "radial-gradient(circle, rgba(99,102,241,0.5), transparent 70%)"
    }} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== top) {
    t3 = top ? <div className="shrink-0 pt-6">{top}</div> : null;
    $[1] = top;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== fill) {
    t4 = fill ? <div className="min-h-0 flex-1 py-4">{children}</div> : <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden"><div className="flex min-h-full flex-col justify-center py-6">{children}</div></div>;
    $[3] = children;
    $[4] = fill;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== footer) {
    t5 = footer ? <div className="shrink-0 pb-6 pt-2">{footer}</div> : null;
    $[6] = footer;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="relative flex h-[100dvh] flex-col overflow-hidden lg:border-r lg:border-ds-border-standard">{t2}<div className="relative z-10 flex h-full flex-col px-6 sm:px-10 lg:px-12">{t3}{t4}{t5}</div></div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="hidden lg:block"><BrandPanel /></div>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <div className="w-full bg-background-primary lg:grid lg:grid-cols-[46fr_54fr]">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default OnboardingShell;